/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialDataDto } from '../../models/material-data-dto';
import { MaterialDetailsDto } from '../../models/material-details-dto';

export interface CreateMaterial$Params {
  'X-API-Version'?: string;
      body: MaterialDataDto
}

export function createMaterial(http: HttpClient, rootUrl: string, params: CreateMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, createMaterial.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaterialDetailsDto>;
    })
  );
}

createMaterial.PATH = '/api/materials';
